import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { PurchaseItem, PurchaseListParams } from '~/features/purchases/types/purchases.type';

/**
 * 내 구매내역 목록 조회
 * @endpoint GET /web/purchases-history
 */
export function getPurchasesApi(params?: PurchaseListParams) {
  return axiosInstance.get<PaginatedApiResponse<PurchaseItem>>('/web/purchases-history', {
    params,
  });
}
